import { useSelector } from "react-redux";
import { RootSliceType } from "redux/reducers/rootReducer";
import {IReservationIndividualReserved} from "../reducers/reservationIndividualReservedSlice";

const useReservationIndividualReserved = () => {
    const reservationIndividualReserved = useSelector<
        RootSliceType,
        IReservationIndividualReserved["reservationIndividualReserved"]
        >((state) => state.reservationIndividualReservedSlice.reservationIndividualReserved);

    const loading = useSelector<
        RootSliceType,
        IReservationIndividualReserved["loading"]
        >((state) => state.reservationIndividualReservedSlice.loading);

    return {
        reservationIndividualReserved,
        loading,
    };
};

export default useReservationIndividualReserved;
